import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import { FuelCardsResponse } from './types';

export * from './types';

class FuelCards extends BaseResource {
  path: string = '';

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'v1/cards';
  }

  getFuelCards(): FuelCardsResponse {
    return this.getItems();
  }
}

export default FuelCards;
